module.exports = __webpack_public_path__ + "static/img/19.e388e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/19.png
// module id = dYDP
// module chunks = 0